module.exports = __webpack_public_path__ + "img/simplesotimizado.74fd9457.png";